import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

const MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const monthFromDateString = (dateString) => {
  if (!dateString) return null;
  const d = dayjs(dateString);
  if (!d.isValid()) return null;
  return { year: d.year(), monthIndex: d.month() };
};

export const calendarMonthRange = (year, monthIndex) => {
  const start = dayjs(new Date(year, monthIndex, 1));
  return {
    from: start.format("YYYY-MM-DD"),
    to: start.endOf("month").format("YYYY-MM-DD"),
  };
};

const CalendarMonthButtons = ({ dateFilter, onChange }) => {
  const currentSelection = monthFromDateString(dateFilter?.from);
  const today = dayjs();
  const displayedYear = currentSelection?.year ?? today.year();
  const selectedMonth =
    currentSelection?.year === displayedYear
      ? currentSelection.monthIndex
      : null;

  const setYear = (delta) => {
    const nextYear = displayedYear + delta;
    const monthIndex = selectedMonth ?? today.month();
    onChange(calendarMonthRange(nextYear, monthIndex));
  };

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      spacing={0.5}
      flexWrap={"wrap"}
    >
      <IconButton
        size={"small"}
        onClick={() => setYear(-1)}
        aria-label={"Previous year"}
      >
        <ChevronLeftIcon fontSize={"small"} />
      </IconButton>
      <Typography
        variant={"body2"}
        sx={{ minWidth: "3em", textAlign: "center", fontWeight: 600 }}
      >
        {displayedYear}
      </Typography>
      <IconButton
        size={"small"}
        onClick={() => setYear(1)}
        aria-label={"Next year"}
      >
        <ChevronRightIcon fontSize={"small"} />
      </IconButton>
      {MONTH_LABELS.map((label, monthIndex) => {
        const isSelected = selectedMonth === monthIndex;
        return (
          <Button
            key={label}
            size={"small"}
            variant={isSelected ? "contained" : "outlined"}
            color={"primary"}
            onClick={() =>
              onChange(calendarMonthRange(displayedYear, monthIndex))
            }
            sx={{
              minWidth: "3em",
              px: 1,
              textTransform: "none",
              ...(isSelected
                ? {}
                : {
                    color: "text.primary",
                    borderColor: "divider",
                    "&:hover": {
                      borderColor: "primary.main",
                      backgroundColor: "action.hover",
                    },
                  }),
            }}
          >
            {label}
          </Button>
        );
      })}
    </Stack>
  );
};

export default CalendarMonthButtons;
